export const supportedThemeSVGs: { [src: string]: boolean } = {
    'access_denied.svg': true,
    'actions_disabled.svg': true,
    'actions_hover.svg': true,
    'actions_normal.svg': true,
    'alert_14px-small.svg': true,
    'alert_hover.svg': true,
    'alert_list_header_normal.svg': true,
    'alert_normal.svg': true,
    'analytics_extensions_api.svg': true,
    'arrow_chevron_down_14px-small.svg': true,
    'arrow_chevron_down_14px-small_new.svg': true,
    'arrow_chevron_right_14px-small_new.svg': true,
    'arrow_chevron_up_14px-small.svg': true,
    'arrow_right_14px-small.svg': true,
    'arrow_style1_right.svg': true,
    'back_arrow.svg': true,
    'broadcast_arrow_chevron_down_14px.svg': true,
    'broadcast_arrow_chevron_up_14px.svg': true,
    'broadcast_embed_base_14px.svg': true,
    'broadcast_link_icon.svg': true,
    'broadcast_view_base_14px.svg': true,
    'checkbox_empty_disabled.svg': true,
    'checkbox_empty_hover.svg': true,
    'checkbox_empty_normal.svg': true,
    'checkbox_mixed_disabled.svg': true,
    'checkbox_mixed_hover.svg': true,
    'checkbox_mixed_normal.svg': true,
    'checkbox_selected_disabled.svg': true,
    'checkbox_selected_hover.svg': true,
    'checkbox_selected_normal.svg': true,
    'check_12px-xsmall.svg': true,
    'check_14px-small.svg': true,
    'clear_14px-small.svg': true,
    'clear_focus_14px-small.svg': true,
    'clock_base.svg': true,
    'close_x_hover.svg': true,
    'collectionSpace_EmptyState.svg': true,
    'column_dropdown_arrow_hover.svg': true,
    'common_alert_error.svg': true,
    'common_alert_warning.svg': true,
    'content_type_attached_pdf_small.svg': true,
    'copy_paste_14px-small.svg': true,
    'data-source-icon-loading.svg': true,
    'database_server_card.svg': true,
    'datasource_12px-xsmall.svg': true,
    'datasource_18px-large.svg': true,
    'datasource_36px-jumbo.svg': true,
    'datasource_certified_36px-jumbo.svg': true,
    'datasource_embedded_18px-large.svg': true,
    'datasource_extract embedded_80px_empty.svg': true,
    'datasource_extract_14px_small.svg': true,
    'datasource_extract_18px-large.svg': true,
    'datasource_extract_60px_card.svg': true,
    'datasource_extract_embedded_60px-card.svg': true,
    'datasource_server_connection_base_14px.svg': true,
    'datasource_server_connection_extract_14px.svg': true,
    'data_change_large_18px.svg': true,
    'data_prep_info.svg': true,
    'data_prep_info_active.svg': true,
    'data_source_content_type.svg': true,
    'data_source_content_type_hover_small.svg': true,
    'data_source_content_type_small.svg': true,
    'data_source_embedded_content_type_small.svg': true,
    'dialogs_status_alert.svg': true,
    'dialogs_status_alert_active.svg': true,
    'dialogs_warning.svg': true,
    'dialogs_workbook.svg': true,
    'download_14px_normal.svg': true,
    'download_small_hover.svg': true,
    'download_small_normal.svg': true,
    'down_arrow_normal.svg': true,
    'dropdown_arrow_disabled.svg': true,
    'dropdown_arrow_normal.svg': true,
    'dropdown_arrow_pressed.svg': true,
    'edit_small_hover.svg': true,
    'edit_small_normal.svg': true,
    'einstein_discovery_new_connection.svg': true,
    'explorer-dropdown-check-disabled.svg': true,
    'explorer-dropdown-check.svg': true,
    'extension.svg': true,
    'external_server_connection_16px.svg': true,
    'external_server_connection_type_card.svg': true,
    'external_server_connection_type_small.svg': true,
    'favorite_selected_12px-xsmall.svg': true,
    'favorite_unselected_12px-xsmall.svg': true,
    'File_14px-small.svg': true,
    'file_card.svg': true,
    'file_connection_type_card.svg': true,
    'file_connection_type_small.svg': true,
    'File_excel_14px-small.svg': true,
    'filmstrip_arrow_chevron_left.svg': true,
    'filmstrip_arrow_chevron_right.svg': true,
    'filter_toggle_normal.svg': true,
    'filter_toggle_selected.svg': true,
    'flow_36px-jumbo.svg': true,
    'flow_content_type.svg': true,
    'flow_content_type_small.svg': true,
    'flow_run_cancelled.svg': true,
    'flow_run_error.svg': true,
    'flow_run_in_progress.svg': true,
    'flow_run_pending.svg': true,
    'flow_run_succeeded.svg': true,
    'folder_hollow_open_36px-jumbo.svg': true,
    'for_you_large_18px.svg': true,
    'goto_generic_10px_xxsmall.svg': true,
    'goto_generic_14px-small.svg': true,
    'group_content_type.svg': true,
    'group_small.svg': true,
    'header_ellipsis_hover.svg': true,
    'help_header_icon_dark.svg': true,
    'hide_password_16px.svg': true,
    'home_welcome_screen_bottom_color_dark.svg': true,
    'home_welcome_screen_main_dark.svg': true,
    'image_hint_icon.svg': true,
    'info_14px_small.svg': true,
    'info_20px.svg': true,
    'info_hover.svg': true,
    'info_normal.svg': true,
    'labels_tagIcon.svg': true,
    'locked_gray_normal.svg': true,
    'locked_mixed_gray_normal.svg': true,
    'locked_mixed_white_normal.svg': true,
    'locked_white_normal.svg': true,
    'lock_14px-small.svg': true,
    'lock_locked_14px-small.svg': true,
    'lock_locked_small.svg': true,
    'lock_unlocked_14px-small.svg': true,
    'Loom_Details_Profile_Bool_Discrete.svg': true,
    'Loom_Details_Profile_DateTime_Discrete.svg': true,
    'Loom_Details_Profile_Date_Discrete.svg': true,
    'Loom_Details_Profile_Numeric_Discrete.svg': true,
    'Loom_Details_Profile_Text_Discrete.svg': true,
    'Loom_Flow_Step_Input_DS.svg': true,
    'Loom_Flow_Step_Input_File.svg': true,
    'magnifying_glass_large_hover.svg': true,
    'magnifying_glass_large_normal.svg': true,
    'magnifying_glass_large_white_hover.svg': true,
    'magnifying_glass_large_white_normal.svg': true,
    'magnifying_glass_small_hover.svg': true,
    'magnifying_glass_small_normal.svg': true,
    'menu_edit.svg': true,
    'modal_arrow_up.svg': true,
    'narrow_sort_arrow_ascending.svg': true,
    'narrow_sort_arrow_descending.svg': true,
    'nav_arrow_right.svg': true,
    'new_workbook_small_hover.svg': true,
    'new_workbook_small_normal.svg': true,
    'notification_alert_error.svg': true,
    'notification_alert_low_shield.svg': true,
    'notification_empty_bell.svg': true,
    'notification_success.svg': true,
    'panel_hide_hover.svg': true,
    'panel_hide_normal.svg': true,
    'panel_show_hover.svg': true,
    'panel_show_normal.svg': true,
    'pencil_14px_small.svg': true,
    'permission_capability_add_comment.svg': true,
    'permission_capability_add_comment_disabled.svg': true,
    'permission_capability_change_hierarchy.svg': true,
    'permission_capability_change_hierarchy_disabled.svg': true,
    'permission_capability_change_permissions.svg': true,
    'permission_capability_change_permissions_disabled.svg': true,
    'permission_capability_connect.svg': true,
    'permission_capability_connect_disabled.svg': true,
    'permission_capability_define_pulse_metric.svg': true,
    'permission_capability_define_pulse_metric_disabled.svg': true,
    'permission_capability_delete.svg': true,
    'permission_capability_delete_disabled.svg': true,
    'permission_capability_execute.svg': true,
    'permission_capability_execute_disabled.svg': true,
    'permission_capability_explain_data.svg': true,
    'permission_capability_explain_data_disabled.svg': true,
    'permission_capability_export_data.svg': true,
    'permission_capability_export_data_disabled.svg': true,
    'permission_capability_export_image.svg': true,
    'permission_capability_export_image_disabled.svg': true,
    'permission_capability_export_xml_datasource.svg': true,
    'permission_capability_export_xml_datasource_disabled.svg': true,
    'permission_capability_export_xml_flow.svg': true,
    'permission_capability_export_xml_flow_disabled.svg': true,
    'permission_capability_export_xml_workbook.svg': true,
    'permission_capability_export_xml_workbook_disabled.svg': true,
    'permission_capability_extract_refresh.svg': true,
    'permission_capability_extract_refresh_disabled.svg': true,
    'permission_capability_filter.svg': true,
    'permission_capability_filter_disabled.svg': true,
    'permission_capability_project_leader.svg': true,
    'permission_capability_project_leader_disabled.svg': true,
    'permission_capability_read.svg': true,
    'permission_capability_read_disabled.svg': true,
    'permission_capability_save_as_datasource.svg': true,
    'permission_capability_save_as_datasource_disabled.svg': true,
    'permission_capability_share_view.svg': true,
    'permission_capability_share_view_disabled.svg': true,
    'permission_capability_view_comments.svg': true,
    'permission_capability_view_comments_disabled.svg': true,
    'permission_capability_vizql_data_api_access.svg': true,
    'permission_capability_vizql_data_api_access_disabled.svg': true,
    'permission_capability_vud.svg': true,
    'permission_capability_vud_disabled.svg': true,
    'permission_capability_web_authoring.svg': true,
    'permission_capability_web_authoring_disabled.svg': true,
    'permission_capability_web_authoring_for_flows.svg': true,
    'permission_capability_web_authoring_for_flows_disabled.svg': true,
    'permission_capability_write.svg': true,
    'permission_capability_write_disabled.svg': true,
    'permission_rule_add.svg': true,
    'permission_rule_add_disabled.svg': true,
    'plus_14px-small.svg': true,
    'project_content_type.svg': true,
    'project_content_type_hover_small.svg': true,
    'project_content_type_small.svg': true,
    'radio_button_empty_disabled.svg': true,
    'radio_button_empty_hover.svg': true,
    'radio_button_empty_normal.svg': true,
    'radio_button_mixed_disabled.svg': true,
    'radio_button_mixed_hover.svg': true,
    'radio_button_mixed_normal.svg': true,
    'radio_button_selected_disabled.svg': true,
    'radio_button_selected_hover.svg': true,
    'radio_button_selected_normal.svg': true,
    'refresh_hover.svg': true,
    'refresh_normal.svg': true,
    'remote_agent_upgrade_required.svg': true,
    'rename_hover.svg': true,
    'rename_normal.svg': true,
    'ribbon_DataChange.svg': true,
    'ribbon_DataChange_Long.svg': true,
    'ribbon_ForYou.svg': true,
    'ribbon_ForYou_Long.svg': true,
    'ribbon_Trending.svg': true,
    'ribbon_Trending_Long.svg': true,
    'rserve_new_connection.svg': true,
    'run_now_small.svg': true,
    'run_now_small_hover.svg': true,
    'schedule_content_type.svg': true,
    'schedule_content_type_small.svg': true,
    'server_36px-jumbo-copy.svg': true,
    'server_alert_list_suspended.svg': true,
    'server_alert_list_suspended_active.svg': true,
    'server_certified_36px-jumbo.svg': true,
    'server_node_status_inprogress_active.svg': true,
    'server_node_status_late_active.svg': true,
    'server_node_status_suspended.svg': true,
    'server_viz_portal_effective_permission_allowed_disabled.svg': true,
    'server_viz_portal_effective_permission_allowed_green.svg': true,
    'server_viz_portal_effective_permission_denied_disabled.svg': true,
    'server_viz_portal_effective_permission_denied_red.svg': true,
    'server_viz_portal_effective_permission_mixed_disabled.svg': true,
    'server_viz_portal_effective_permission_mixed_gray.svg': true,
    'server_viz_portal_permission_rule_allowed_white.svg': true,
    'server_viz_portal_permission_rule_denied_white.svg': true,
    'server_viz_portal_permission_rule_mixed_white.svg': true,
    'share.svg': true,
    'share_18_large.svg': true,
    'share_active.svg': true,
    'share_disabled.svg': true,
    'shield_14px_small.svg': true,
    'show_nav.svg': true,
    'show_nav_hover.svg': true,
    'show_password_16px.svg': true,
    'SignIn_Arrow_White.svg': true,
    'skip_to_content_arrow.svg': true,
    'Slack_Integration_Logo.svg': true,
    'sort_arrow_ascending.svg': true,
    'sort_arrow_descending.svg': true,
    'spaces_broadcast_spot_60px.svg': true,
    'Spaces_Caption_Favorite_Off.svg': true,
    'Spaces_Caption_Favorite_Off_Active.svg': true,
    'Spaces_Caption_Favorite_Off_Active_White.svg': true,
    'Spaces_Caption_Favorite_Off_White.svg': true,
    'Spaces_Caption_Favorite_On.svg': true,
    'Spaces_Caption_Favorite_On_Active.svg': true,
    'Spaces_Caption_Favorite_On_Active_White.svg': true,
    'Spaces_Caption_Favorite_On_White.svg': true,
    'spaces_card_ds.svg': true,
    'spaces_card_ds_embedded.svg': true,
    'spaces_card_extract.svg': true,
    'spaces_card_view.svg': true,
    'spaces_card_views.svg': true,
    'spaces_card_workbook.svg': true,
    'Spaces_Data_Status.svg': true,
    'spaces_empty_favorite.svg': true,
    'spaces_empty_recent.svg': true,
    'spaces_empty_recommendation.svg': true,
    'spaces_filter_large.svg': true,
    'spaces_masthead_ds_embedded.svg': true,
    'spaces_masthead_extract.svg': true,
    'spaces_masthead_flow.svg': true,
    'spaces_masthead_groups.svg': true,
    'spaces_masthead_project.svg': true,
    'spaces_masthead_schedule.svg': true,
    'spaces_masthead_table_connection.svg': true,
    'spaces_masthead_workbook.svg': true,
    'spaces_navigation_admin_settings.svg': true,
    'spaces_search_published_connection.svg': true,
    'spaces_shared_with_me_empty_state.svg': true,
    'spaces_small_flow.svg': true,
    'spaces_toolbar_back.svg': true,
    'spaces_toolbar_back_active.svg': true,
    'spaces_toolbar_back_black.svg': true,
    'spaces_toolbar_back_black_active.svg': true,
    'spaces_toolbar_delete.svg': true,
    'spaces_toolbar_delete_active.svg': true,
    'spaces_toolbar_forward.svg': true,
    'spaces_toolbar_forward_active.svg': true,
    'spaces_toolbar_help.svg': true,
    'spaces_toolbar_help_active.svg': true,
    'spaces_toolbar_help_medium.svg': true,
    'spaces_toolbar_help_medium_active.svg': true,
    'spaces_toolbar_menu.svg': true,
    'spaces_toolbar_menu_active.svg': true,
    'spaces_toolbar_search.svg': true,
    'spaces_toolbar_search_active.svg': true,
    'spaces_viz_view_header_broadcast_base_20px.svg': true,
    'spaces_viz_view_header_broadcast_off_20px.svg': true,
    'spaces_viz_view_header_broadcast_on_20px.svg': true,
    'spaces_viz_view_header_ds.svg': true,
    'spaces_viz_view_header_ds_active.svg': true,
    'spaces_viz_view_header_ds_active_dark.svg': true,
    'spaces_viz_view_header_ds_dark.svg': true,
    'speed_base_18px.svg': true,
    'spot_datasource_type_server_connection_base_60px.svg': true,
    'spot_datasource_type_server_connection_extract_60px.svg': true,
    'star_empty_small_hover.svg': true,
    'star_empty_small_normal.svg': true,
    'star_selected_small_hover.svg': true,
    'star_selected_small_normal.svg': true,
    'status_active_14px_small.svg': true,
    'status_active_18px-large.svg': true,
    'status_down_14px-small.svg': true,
    'status_down_18px-large.svg': true,
    'status_error_14px-small.svg': true,
    'status_error_18px-large.svg': true,
    'status_inprogress_14px-small.svg': true,
    'Tableau_Logo_Mark.svg': true,
    'tableau_server_connection_type_card.svg': true,
    'tableau_server_connection_type_small.svg': true,
    'tableau_sign_in_logo.svg': true,
    'table_18px-large.svg': true,
    'table_36px-jumbo.svg': true,
    'table_card.svg': true,
    'table_certified_36px-jumbo.svg': true,
    'tabpy_new_connection.svg': true,
    'thumbnail_ellipsis_hover.svg': true,
    'thumbnail_ellipsis_normal.svg': true,
    'tnail_checkbox_selected_hover.svg': true,
    'tnail_checkbox_selected_normal.svg': true,
    'trash_14px_small.svg': true,
    'trending_large_18px.svg': true,
    'unlocked_gray_normal.svg': true,
    'unlocked_white_normal.svg': true,
    'user_content_type.svg': true,
    'view_12px-xsmall.svg': true,
    'view_content_type_attached_all_small.svg': true,
    'view_content_type_hover_small.svg': true,
    'view_content_type_small.svg': true,
    'view_pencil_medium.svg': true,
    'view_pencil_medium_active.svg': true,
    'view_toggle_grid_normal.svg': true,
    'view_toggle_grid_selected.svg': true,
    'view_toggle_list_normal.svg': true,
    'view_toggle_list_selected.svg': true,
    'widget_small_close.svg': true,
    'widget_small_close_active.svg': true,
    'workbook_12px-xsmall.svg': true,
    'workbook_content_type.svg': true,
    'workbook_content_type_attached_all_small.svg': true,
    'workbook_content_type_hover_small.svg': true,
    'workbook_content_type_small.svg': true,
    'Blue_Gray_Gradient.png': true,
    'project-thumb-1.png': true,
    'project-thumb-2.png': true,
    'project-thumb-3.png': true,
};